<template>
  <div class="chart-container" style="position: relative; height:30%; width:98%">
    <canvas ref="chartEl" width="98%" height="30%">
      <p>Battery chart</p>
    </canvas>
  </div>
</template>
<script>
/* eslint-disable */
import Chart from 'chart.js';
import gql from 'graphql-tag';
import moment from 'moment';
import EventBus from '@/utils/EventBus';

const QUERY_BATTERY = gql`
query query_battery($id: String!, $startTime: timestamptz!, $endTime: timestamptz!) {
  battery (
    where: {
      _and: [
        {
          device_id: {
            _eq: $id
          }
        },
        {
          timestamp: {
            _gt: $startTime
          }
        },
        {
          timestamp: {
            _lt: $endTime
          }
        }
      ]
    }
    order_by: {
      timestamp: asc
    }
  ) {
    level
    timestamp
  }
}
`;
const SUBSCRIPTION_BATTERY = gql`
subscription subscription_battery($id: String!, $timestamp: timestamptz) {
  battery (
    where: {
      device_id: {
        _eq: $id
      }
      timestamp:{
        _gt: $timestamp
      }
    }
    order_by: {
      timestamp: desc
    }
    limit: 1
  ) {
    level
    timestamp
  }
}
`;

export default {
  props: {
    id: {
      type: String,
      required: true,
    },
    start: {
      type: String,
      required: true,
    },
    end: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      batteries: [],
      chartUI: null,
      startTime: this.start,
      endTime: this.end,
      subscription: null,
      showNewValues: true,
    };
  },
  created() {
    EventBus.$on('monitoring-time-changed', this.reCreateChart);
  },
  beforeDestroy() {
    if (this.chartUI) {
      this.chartUI.destroy();
    }
    EventBus.$off('monitoring-time-changed', this.reCreateChart);
  },
  async mounted() {
    // wait for battery values
    await this.getBatteries();
    // create chartjs UI
    this.createChart();
    // subscribe to new battery values
    this.subcribeNewBatteries();
  },
  methods: {
    async reCreateChart(data) {
      this.startTime = data.startTime;
      this.endTime = data.endTime;
      // wait for battery values
      await this.getBatteries();
      // create chartjs UI
      if (this.chartUI) {
        this.chartUI.destroy();
      }
      this.createChart();
      /*
      if (data.subscribe) {
        console.log('show new values');
      } else {
        this.stopSubscription();
      }
      */
    },
    stopSubscription() {
      console.log('Don\'t show new values');
    },
    async getBatteries() {
      const result = await this.$apollo.query({
        query: QUERY_BATTERY,
        variables: {
          id: this.id,
          startTime: this.startTime,
          endTime: this.endTime,
        },
      });

      // create values for chartjs
      this.batteries = result.data.battery.map((battery) => ({
        x: new Date(battery.timestamp),
        y: parseInt(battery.level),
      }));
    },
    createChart() {
      // create chartjs UI
      const config = {
        type: 'line',
        data: {
          datasets: [{
            backgroundColor: 'rgba(0,255,0,0.5)',
            borderColor: '#00ff00',
            fill: false,
            data: this.batteries
          }]
        },
        options: {
          responsive: true,
          scales: {
            xAxes: [{
              gridLines: {
                color: 'rgba(150, 150, 150, 0.5)'
              },
              type: 'time',
              time: {
                tooltipFormat: 'YYYY-MM-DD HH:mm',
                displayFormats: {
                    millisecond: 'HH:mm:ss.SSS',
                    second: 'HH:mm:ss',
                    minute: 'HH:mm',
                    hour: 'HH'
                },
                unit: 'minute',
                stepSize: 30,
              },
            }],
            yAxes: [{
              display: true,
              ticks: {
                beginAtZero: true,
                min: 0,
                max: 100,
                stepSize: 10,
              },
              gridLines: {
                color: 'rgba(150, 150, 150, 0.5)'
              },
            }]
          },
          legend: {
            display: false,
          },
          title: {
            display: true,
            text: 'Battery (%)'
          }
        }
      };
      const { chartEl } = this.$refs;
      this.chartUI = new Chart(chartEl, config);
    },
    subcribeNewBatteries() {
      const { id } = this;
      const that = this;
      const timestamp = new Date().toISOString();

      // start subscribing to new battery values
      this.subscription = this.$apollo.subscribe({
        query: SUBSCRIPTION_BATTERY,
        variables: {
          id,
          timestamp
        },
      });
      this.subscription.subscribe({
          next(data) {
            // got new subscription result
            if (data.data.battery.length > 0) {
              // Add new battery value to chart
              that.addData(data.data.battery[0]);
            }
          },
          error(err) { console.error('err', err); },
      });
    },
    addData(data) {
      // create new value for chartjs
      const value = {
        x: new Date(data.timestamp),
        y: parseInt(data.level),
      };

      // Add chartjs data
      this.chartUI.data.labels.push(data.timestamp);
      this.chartUI.data.datasets.forEach((dataset) => {
        dataset.data.push(value);
      });

      // Update chartjs UI
      this.chartUI.update();
    },
  },
};
</script>
<style scoped>
</style>
